import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, ShoppingBag, Package, Wallet, User } from "lucide-react";

// Maritime Supply Suite Premium Palette
const colors = {
  active: "#03f8d7",
  inactive: "#94a3b8",
  navBg: "#1e293b",
  bodyBg: "#0a0a0b", 
  badge: "#ef4444",
};

// Moved OUTSIDE to fix the ESLint dependency warning
const TABS_CONFIG = [
  { label: "Catalog", path: "/", icon: Home },
  { label: "Inventory", path: "/products", icon: ShoppingBag },
  { label: "Manifests", path: "/orders", icon: Package },
  { label: "Wallet", path: "/wallet", icon: Wallet },
  { label: "Profile", path: "/profile", icon: User },
];

function BottomNav({ unreadMessagesCount = 0, assignedProductsCount = 0 }) {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);

  // Extract tenant context identifier
  const tenantId = localStorage.getItem("adminId") || "global";

  useEffect(() => {
    const index = TABS_CONFIG.findIndex(tab => tab.path === location.pathname);
    if (index !== -1) setActiveIndex(index);
  }, [location.pathname]);

  return (
    <div className="navigation-wrapper" data-tenant-scope={tenantId}>
      <style>
        {`
          .navigation-wrapper {
            position: fixed;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            width: 400px;
            height: 70px;
            background: ${colors.navBg};
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 15px;
            z-index: 10000;
            box-shadow: 0 10px 25px rgba(0,0,0,0.5);
          }
          .navigation-wrapper ul {
            display: flex;
            width: 350px;
            padding: 0;
            margin: 0;
            position: relative;
          }
          .navigation-wrapper ul li {
            position: relative;
            list-style: none;
            width: 70px;
            height: 70px;
            z-index: 1;
          }
          .navigation-wrapper ul li a {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 100%;
            text-align: center;
            text-decoration: none;
          }
          .navigation-wrapper ul li a .icon {
            position: relative;
            display: block;
            line-height: 75px;
            font-size: 1.5em;
            transition: 0.5s;
            color: ${colors.inactive};
          }
          .navigation-wrapper ul li.active a .icon {
            transform: translateY(-35px);
            color: ${colors.active};
          }
          .navigation-wrapper ul li a .text {
            position: absolute;
            color: ${colors.active};
            font-weight: 700;
            font-size: 0.75em;
            letter-spacing: 0.05em;
            transition: 0.5s;
            opacity: 0;
            transform: translateY(20px);
          }
          .navigation-wrapper ul li.active a .text {
            opacity: 1;
            transform: translateY(12px);
          }
          .magic-indicator {
            position: absolute;
            top: -50%;
            width: 70px;
            height: 70px;
            background: ${colors.navBg};
            border-radius: 50%;
            border: 6px solid ${colors.bodyBg};
            transition: 0.5s;
            z-index: 0;
          }
          .magic-indicator::before {
            content: '';
            position: absolute;
            top: 50%;
            left: -22px;
            width: 20px;
            height: 20px;
            background: transparent;
            border-top-right-radius: 20px;
            box-shadow: 1px -10px 0 0 ${colors.bodyBg};
          }
          .magic-indicator::after {
            content: '';
            position: absolute;
            top: 50%;
            right: -22px;
            width: 20px;
            height: 20px;
            background: transparent;
            border-top-left-radius: 20px;
            box-shadow: -1px -10px 0 0 ${colors.bodyBg};
          }
          .badge {
            position: absolute;
            top: 15px;
            right: 15px;
            background: ${colors.badge};
            color: white;
            min-width: 16px;
            height: 16px;
            border-radius: 50%;
            font-size: 9px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid ${colors.navBg};
            transition: 0.5s;
          }
          .active .badge {
            transform: translateY(-35px);
          }
        `}
      </style>

      <ul>
        {TABS_CONFIG.map((tab, index) => {
          const Icon = tab.icon;
          const isActive = activeIndex === index;
          
          const hasBadge = (tab.label === "Inventory" && assignedProductsCount > 0) || 
                          (tab.label === "Settings" && unreadMessagesCount > 0);
          const badgeCount = tab.label === "Settings" ? unreadMessagesCount : "";

          return (
            <li key={tab.path} className={isActive ? "active" : ""}>
              <Link to={tab.path}>
                <span className="icon">
                  <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
                </span>
                <span className="text">{tab.label}</span>
                {hasBadge && (
                  <div className="badge">{badgeCount}</div>
                )}
              </Link>
            </li>
          );
        })}
        <div 
          className="magic-indicator" 
          style={{ transform: `translateX(calc(70px * ${activeIndex}))` }}
        ></div>
      </ul>
    </div>
  );
}

export default BottomNav;